import { Routes } from "@/constants/routes";

export const navigation = [
    {
        label: 'GAMES',
        href: Routes.Games
    },
    {
        label: 'CAREERS',
        href: Routes.Careers
    },
    {
        label: 'CONTACTS',
        href: Routes.Contacts
    }
] as const